import * as Stimulus from "@hotwired/stimulus"

export class LocaltimeController extends Stimulus.Controller {
    static values = {
        'timestamp': String
    };

    connect() {
        if(!this.hasTimestampValue) {
            DEV: console.warn('LocaltimeController', 'No timestamp value found');
            return;
        }

        let d = new Date(this.timestampValue);
        this.element.title = this.element.innerHTML;
        this.element.innerHTML = d.toLocaleDateString('en-us',
            { year: "numeric"
            , month: "long"
            , day: "numeric"
            , hour: "numeric"
            , hourCycle: "h12"
            , minute: "numeric"
            , timeZoneName: "short"
            }
        );
    }
}
